export class UpdatedBeneficiary {
  constructor(
    public firstname: string,
    public lastname: string,
    public dateBirth: Date,
    public city: number,
    public country: number,
    public nationalite: string,
    public email: string,
    public phoneNumberOne: string,
    public phoneNumberTwo: string,
    public waveNumber: string
  ) {}
}
